import { postApprovalRequest } from '@gonfalon/openapi/operations/postApprovalRequest';

import { createMutationHook } from '../internal/createMutationHook';

export const useCreateApprovalRequest = createMutationHook(postApprovalRequest);
